module.exports = __webpack_public_path__ + "logo.99270c92e190eb71d31b.png";


//////////////////
// WEBPACK FOOTER
// /Users/sam/Documents/Work/DevelopLLC/Falcon/web/acct-falcon-dashboard/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = styles